module.exports = __webpack_public_path__ + "static/media/thegalteegroup.c7d28c94.png";